<template>
  <div class="inline-batch-card">
    <div class="inline-batch-card-data">
      <div class="inline-batch-card-data-list">
        <div class="inline-batch-card-data-list-item skeleton" />

        <div class="inline-batch-card-data-list-item skeleton" />

        <div class="inline-batch-card-data-list-item skeleton" />
      </div>

      <div class="inline-batch-card-data-packaging">
        <div class="inline-batch-card-data-packaging-box" />
      </div>
    </div>

    <div class="inline-batch-card-separator" />

    <div class="inline-batch-card-samples-amount">
      <div class="inline-batch-card-samples-amount-value">
        0
      </div>

      <div class="inline-batch-card-samples-amount-label">
        Amostras
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineBatchCardSkeleton'
}
</script>

<style lang="scss" scoped>
.skeleton {
  background-color: #ffffff;
  animation: loading 1.5s infinite;
  background-position: -400px;
  background-size: 100% 100%;
  background-image: linear-gradient(90deg, hsla(0, 20%, 97.1%, 0.4), hsla(0, 2.1%, 62.7%, 0.2) 50%, hsl(0, 0%, 100%));
  background-repeat: no-repeat;
  border-radius: 0.25rem;
}

@keyframes loading {
  to {
    background-position: 400px;
  }
}

.inline-batch-card {
  display: flex;
  padding: 1rem;
  gap: 0.5rem;
  border-radius: 0.25rem;
  box-shadow: 0px 4px 10px 0px #8181810D;
  width: 305px;

  &-data {
    flex: 1;
    display: flex;
    gap: 1rem;

    &-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      &-item {
        display: flex;
        gap: 0.5rem;
        height: 1.25rem;
      }
    }

    &-packaging {
      &-box {
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 0.1875rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-icon {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  &-separator {
    width: 1px;
    background-color: #CCCCCC;
  }

  &-samples-amount {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    &-value {
      font-weight: 700;
      font-size: 1.75rem;
      filter: blur(0.5rem);
    }

    &-label {
      text-transform: uppercase;
      color: #818181;
      filter: blur(0.25rem);
    }
  }
}
</style>
